// @ts-nocheck
import { Category } from "@insite/client-framework/Services/CategoryService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { useSelector } from "react-redux";

export default (categoryIds: readonly string[]) =>
    useSelector((state: ApplicationState) => {
        return categoryIds
            .map(id => getCategoryState(state, id).value)
            .filter((category): category is Readonly<Category> => !!category);
    });
